/* eslint-disable react/require-default-props */
import React, { Component } from "react";
import PropTypes from "prop-types";

import $ from "jquery";
// eslint-disable-next-line import/extensions
import "selectize/dist/js/standalone/selectize.min.js";

class SelectField extends Component {
  componentDidMount() {
    this.name = this.textInput.getAttribute("name");
    const { onChange } = this.props;

    // initialize the Selectize control
    $(this.textInput).selectize({
      onChange: value => {
        onChange({ [this.name]: value });
      }
    });
  }

  // eslint-disable-next-line class-methods-use-this
  renderOption(option, i) {
    const { value, text } = option;
    return (
      <option key={i} value={value}>
        {text}
      </option>
    );
  }

  render() {
    const { name, options } = this.props;

    return (
      <select
        ref={e => {
          this.textInput = e;
        }}
        name={name}
        className="select-field"
      >
        {options.map(this.renderOption)}
      </select>
    );
  }
}

SelectField.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func
};

export default SelectField;
